export async function initMSW() {
  if (
    typeof window !== 'undefined' &&
    process.env.NEXT_PUBLIC_ENABLE_MSW === 'true' &&
    window.location.hostname === 'localhost'
  ) {
    try {
      const { worker } = await import(/* webpackChunkName: "msw-browser" */ '@src/mock-apis/browser')
      await worker.start({
        onUnhandledRequest: 'bypass',
        serviceWorker: {
          // @i18n-ignore
          url: `/mockServiceWorker.js` as const,
        },
      })
      // eslint-disable-next-line no-console
      console.log('[MSW] Mock Service Worker started')
    } catch (error) {
      console.error('[MSW] Error initializing Mock Service Worker:', error)
    }
  }
}
